import React from 'react'
import "./Respond.scss"
import { Link } from 'react-router-dom'
import { HERO_BUDGET_BODY } from "../../content/landingContent"
import huswife from "../../../src/Assets/huswife.png"
export default function Respond() {

    return (
        <div>
            <section className="hero_section">
                <div className="container ">

                    <div className="set_your_flex">
                        {/* LEFT CONTENT */}
                        <div className="hero_left price">
                            <h3>
                                Tell us <span className='wgreen'>your budget</span> and compare <span className='wgreen'>real surgery prices</span>
                            </h3>

                            <p>{HERO_BUDGET_BODY}</p>

                            <div className="hero_btns">
                                <div className="btn_primary now">
                                    <Link to="/get-started">Start now</Link>
                                </div>

                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="hero_right price">
                            <img src={huswife} alt="Doctors" className="hero_img" />


                        </div>
                    </div>

                </div>
            </section>
        </div>
    )
}
